// MVM catalog — the storefront reads products live from the merchant's
// Ecwid store via GET /api/catalog (see data/catalog.jsx). This file now
// serves two purposes: (1) offline fallback if Ecwid is unreachable,
// (2) static merchandising data (COLLECTIONS) and formatPrice.

export const PRODUCTS = [
  {
    id: "onyx-motion-tee",
    name: "Onyx Black Motion Tee",
    price: 30,
    category: "men",
    collection: "training",
    tag: "new",
    colors: [{ name: "Onyx Black", hex: "#0A0A0A" }],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: [
      "/assets/products/onyx-b.webp",
      "/assets/products/onyx-a.webp",
      "/assets/products/onyx-d.webp",
      "/assets/products/onyx-e.webp",
      "/assets/products/onyx-c.webp",
      "/assets/products/onyx-f.webp",
      "/assets/products/onyx-g.webp",
      "/assets/products/onyx-h.webp",
      "/assets/products/onyx-i.webp",
    ],
    description:
      "The Motion Tee in Onyx Black. A clean athletic cut with the MVM chest mark — built for training days and everything in between.",
    details: ["MVM chest mark", "Relaxed athletic cut", "Side seam woven label", "Machine washable"],
  },
  {
    id: "onyx-motion-shorts",
    name: "Onyx Motion Shorts",
    price: 50,
    category: "men",
    collection: "training",
    tag: "new",
    colors: [{ name: "Onyx Black", hex: "#0A0A0A" }],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: [
      "/assets/products/oshorts-b.webp",
      "/assets/products/oshorts-c.webp",
      "/assets/products/oshorts-d.webp",
      "/assets/products/oshorts-a.webp",
    ],
    description:
      "The Onyx Motion Shorts in black. MVM wordmark on one leg, the mark on the other, drawcord waist and the MVD-0853 label with red stitch detailing.",
    details: ["MVM wordmark + mark leg prints", "Drawcord waist", "MVD-0853 side label", "Red bar-tack stitch detail"],
  },
  {
    id: "grey-motion-shorts",
    name: "Grey Motion Shorts",
    price: 40,
    category: "men",
    collection: "training",
    tag: "new",
    colors: [{ name: "Mist Grey", hex: "#B9C6CC" }],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: [
      "/assets/products/ls-d.webp",
      "/assets/products/shorts-b.webp",
      "/assets/products/shorts-c.webp",
      "/assets/products/shorts-a.webp",
    ],
    description:
      "The Grey Motion Shorts. MVM wordmark on one leg, the mark on the other — with a drawcord waist and the MVD-0863 side label.",
    details: ["MVM wordmark + mark leg prints", "Drawcord waist", "MVD-0863 side label", "Above-knee athletic cut"],
  },
  {
    id: "athletic-long-sleeve",
    name: "Athletic Long Sleeve",
    price: 60,
    category: "men",
    collection: "training",
    tag: "new",
    colors: [{ name: "White", hex: "#F2F2F2" }],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: [
      "/assets/products/ls-d.webp",
      "/assets/products/ls-c.webp",
      "/assets/products/ls-b.webp",
      "/assets/products/ls-a.webp",
    ],
    description:
      "The Athletic Long Sleeve in white with the black MVM chest mark. A clean performance layer for training days, cool-downs and cool mornings.",
    details: ["Black MVM chest mark", "Relaxed athletic cut", "Ribbed crew collar", "Clean back"],
  },
  {
    id: "black-beanie",
    name: "Black Beanie",
    price: 20,
    category: "unisex",
    collection: "lifestyle",
    tag: "new",
    colors: [{ name: "Onyx Black", hex: "#0A0A0A" }],
    sizes: ["One Size"],
    images: ["/assets/products/beanie-c.webp", "/assets/products/beanie-d.webp"],
    description:
      "The Black Beanie with the tonal MVM woven label. A soft ribbed knit for cold morning runs, rest days and everything in between.",
    details: ["MVM woven label", "Ribbed knit construction", "Cuffed fit", "One size fits most"],
  },
  {
    id: "grey-beanie",
    name: "Grey Beanie",
    price: 20,
    category: "unisex",
    collection: "lifestyle",
    tag: "new",
    colors: [{ name: "Stone Grey", hex: "#C9CFD2" }],
    sizes: ["One Size"],
    images: ["/assets/products/beanie-a.webp", "/assets/products/beanie-b.webp"],
    description:
      "The Grey Beanie with the black MVM woven label. A soft ribbed knit for cold morning runs, rest days and everything in between.",
    details: ["MVM woven label", "Ribbed knit construction", "Cuffed fit", "One size fits most"],
  },
  {
    id: "signature-stripe-sweatpants",
    name: "Signature Stripe Sweatpants",
    price: 58,
    category: "men",
    collection: "training",
    tag: "new",
    colors: [{ name: "Onyx Black", hex: "#0A0A0A" }],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: [
      "/assets/products/stripe-a.webp",
      "/assets/products/stripe-b.webp",
      "/assets/products/stripe-c.webp",
      "/assets/products/stripe-d.webp",
      "/assets/products/stripe-e.webp",
      "/assets/products/stripe-f.webp",
    ],
    description:
      "The Signature Stripe Sweatpants in Onyx Black. Repeating MVM tape runs the full leg, with the chest mark on the thigh and a zip pocket to keep essentials locked in.",
    details: ["Repeating MVM logo side tape", "MVM thigh mark", "Zip side pocket", "Tapered sweatpant cut"],
  },
  {
    id: "signature-pullover",
    name: "Signature Pullover",
    price: 68,
    category: "men",
    collection: "training",
    tag: "new",
    colors: [{ name: "Onyx Black", hex: "#0A0A0A" }],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: [
      "/assets/products/pullover-b.webp",
      "/assets/products/pullover-a.webp",
      "/assets/products/pullover-c.webp",
      "/assets/products/pullover-d.webp",
      "/assets/products/pullover-e.webp",
      "/assets/products/pullover-f.webp",
      "/assets/products/pullover-g.webp",
      "/assets/products/pullover-h.webp",
    ],
    description:
      "The Signature Pullover in Onyx Black. A hooded layer with contrast piped seams and the MVM chest mark — made for warm-ups, cool-downs and everything between.",
    details: ["MVM chest mark", "Contrast piped seams", "Hooded pullover cut", "MVM hem label"],
  },
  {
    id: "versus-sprint-tee",
    name: "Versus Sprint Tee",
    price: 48,
    category: "men",
    collection: "training",
    tag: "best",
    colors: [
      { name: "Obsidian", hex: "#0A0A0A" },
      { name: "Slate Blue", hex: "#1E3E48" },
      { name: "Stone", hex: "#D9D9D9" },
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: ["/assets/brand/men-gym-2.webp", "/assets/brand/image12.png", "/assets/brand/image10.png"],
    description:
      "The tee you reach for when the work begins. A performance knit with a locked-in athletic fit, built for intervals, lifts and everything after.",
    details: ["Performance knit construction", "Athletic fit", "Sweat-wicking hand feel", "Reflective MVM mark"],
  },
  {
    id: "discipline-tank",
    name: "Discipline Tank",
    price: 42,
    category: "men",
    collection: "training",
    tag: "best",
    colors: [
      { name: "Obsidian", hex: "#0A0A0A" },
      { name: "Olive", hex: "#7B8961" },
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    images: ["/assets/brand/men-gym-4.webp", "/assets/brand/image11.png"],
    description:
      "Discipline over doubt. A cut that stays out of your way under the bar and keeps its shape session after session.",
    details: ["Open-shoulder cut", "Durable stretch knit", "Chest MVM wordmark", "Bar-tested fit"],
  },
  {
    id: "tempo-run-set",
    name: "Tempo Run Set",
    price: 88,
    category: "women",
    collection: "running",
    tag: "new",
    colors: [
      { name: "Obsidian", hex: "#0A0A0A" },
      { name: "Ocean Blue", hex: "#073763" },
      { name: "Mist Blue", hex: "#9DB7CD" },
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    images: ["/assets/community/family-training.webp", "/assets/brand/image12.png"],
    description:
      "Made for city miles at your own pace. A supportive two-piece run set that moves with every stride, start line to finish.",
    details: ["Two-piece run set", "Compressive support", "Lightweight construction", "Sweat-wicking knit"],
  },
  {
    id: "studio-sculpt-set",
    name: "Studio Sculpt Set",
    price: 96,
    category: "women",
    collection: "training",
    tag: null,
    colors: [
      { name: "Sage", hex: "#8E9D8A" },
      { name: "Obsidian", hex: "#0A0A0A" },
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    images: ["/assets/community/movement-class.webp", "/assets/brand/image9.png"],
    description:
      "From Pilates before work to the slow Sunday stretch. A sculpted studio set with a second-skin feel and full freedom of movement.",
    details: ["Second-skin sculpt knit", "High-rise waistband", "Four-way stretch", "Matte finish"],
  },
  {
    id: "off-day-crewneck",
    name: "Off-Day Crewneck",
    price: 78,
    category: "women",
    collection: "lifestyle",
    tag: "best",
    colors: [
      { name: "Stone", hex: "#D9D9D9" },
      { name: "Sage", hex: "#8E9D8A" },
      { name: "Obsidian", hex: "#0A0A0A" },
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    images: ["/assets/community/navy-tracksuits.jpg", "/assets/brand/image9.png"],
    description:
      "Recovery is part of the program. A heavyweight-soft crewneck for the days between the work — coffee runs, long walks, earned rest.",
    details: ["Brushed interior", "Relaxed everyday fit", "Tonal MVM mark", "Ribbed cuffs and hem"],
  },
  {
    id: "execution-short",
    name: "Execution Short",
    price: 54,
    category: "men",
    collection: "training",
    tag: null,
    colors: [
      { name: "Obsidian", hex: "#0A0A0A" },
      { name: "Olive", hex: "#7B8961" },
      { name: "Slate Blue", hex: "#1E3E48" },
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    images: ["/assets/brand/men-gym-3.webp", "/assets/brand/image10.png"],
    description:
      "No excuses. Just execution. A training short with a secure waistband and a cut that clears every squat, sprint and lunge.",
    details: ["Secure drawcord waistband", "Above-knee performance cut", "Lightweight stretch woven", "Hidden zip pocket"],
  },
  {
    id: "baseline-tee",
    name: "Baseline Tee",
    price: 44,
    category: "women",
    collection: "lifestyle",
    tag: "new",
    colors: [
      { name: "Stone", hex: "#D9D9D9" },
      { name: "Mist Blue", hex: "#9DB7CD" },
      { name: "Obsidian", hex: "#0A0A0A" },
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: ["/assets/community/women-bar.webp", "/assets/brand/image11.png"],
    description:
      "The everyday standard. A clean, structured tee that carries the mindset beyond the gym — discipline looks good anywhere.",
    details: ["Structured everyday knit", "Clean crew neckline", "Tonal chest mark", "Holds shape wash after wash"],
  },
  {
    id: "ridge-longline",
    name: "Ridge Longline",
    price: 68,
    category: "men",
    collection: "running",
    tag: "new",
    colors: [
      { name: "Stone", hex: "#D9D9D9" },
      { name: "Slate Blue", hex: "#1E3E48" },
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    images: ["/assets/brand/men-gym-1.webp", "/assets/brand/image10.png"],
    description:
      "For the trails that test you. A breathable long-sleeve layer with a longline cut, built for elevation, weather and the way back down.",
    details: ["Breathable trail knit", "Longline coverage cut", "Thumbhole cuffs", "Back MVM mark"],
  },
  {
    id: "foundation-bra",
    name: "Foundation Bra",
    price: 52,
    category: "women",
    collection: "training",
    tag: null,
    colors: [
      { name: "Stone", hex: "#D9D9D9" },
      { name: "Obsidian", hex: "#0A0A0A" },
      { name: "Sage", hex: "#8E9D8A" },
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    images: ["/assets/community/pink-session.webp", "/assets/brand/image9.png"],
    description:
      "Support you never think about. A medium-support training bra with a cross-back design that stays put through every rep.",
    details: ["Medium support", "Cross-back strap design", "Removable pads", "Soft bonded seams"],
  },
  {
    id: "run-club-tee",
    name: "Run Club Tee",
    price: 46,
    category: "men",
    collection: "running",
    tag: "best",
    colors: [
      { name: "Obsidian", hex: "#0A0A0A" },
      { name: "Ocean Blue", hex: "#073763" },
      { name: "Stone", hex: "#D9D9D9" },
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    images: ["/assets/community/coach-huddle.jpg", "/assets/brand/image12.png"],
    description:
      "Worn by the ones who show up before sunrise. The Run Club tee carries ME VS ME across the back — a signal to everyone chasing you.",
    details: ["Back ME VS ME print", "Breathable run knit", "Reflective details", "Club-fit cut"],
  },
];

export const COLLECTIONS = [
  { id: "men", label: "Men", image: "/assets/brand/men-cat.webp", line: "Built for the work" },
  { id: "women", label: "Women", image: "/assets/brand/women-cat.jpg", line: "Stronger every session" },
  { id: "training", label: "Training", image: "/assets/brand/training-cat.webp", line: "Discipline over doubt" },
  { id: "lifestyle", label: "Lifestyle", image: "/assets/brand/lifestyle-cat.webp", line: "Beyond the gym", pos: "50% 32%" },
  { id: "running", label: "Running", image: "/assets/brand/running-cat-card.jpg", line: "Own every mile", pos: "50% 0%" },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);
export const newArrivals = PRODUCTS.filter((p) => p.tag === "new");
export const bestSellers = PRODUCTS.filter((p) => p.tag === "best");
export const formatPrice = (n) => `$${n.toFixed(0)}`;
